import { generateElementId, generateNodeId } from 'common/utils/generate-id';
import { DEFAULT_MEDIA_QUERY_PLATFORMS, COMPONENT_STATES, COMPONENT_TYPE as TYPE } from 'common/constants';
import { getText } from 'common/utils/dictionary';
import View from 'client/components/common/BuildingBlocks/Button/Button';

export const BUTTON_SHAPE_TYPES = {
	ROUNDED: 'rounded',
	SQUARED: 'squared',
};

/**
 * @param options {Object=}
 * @param options.dictionary {Object=}
 * @returns {{ view, model }}
 * @constructor
 */
export const BUTTON = ({
	dictionary = {},
	type = TYPE.BUTTON,
}: {
	dictionary?: object;
	type?: typeof TYPE.BUTTON_SUBMIT | typeof TYPE.BUTTON;
} = {}) => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			return {
				_id,
				type,
				uiConfig: {
					layer: undefined,
					editorProps: {
						name: BUTTON.displayName,
						selectable: true,
						draggable: true,
						expandable: false,
						expanded: false,
					},
					nodeProps: {
						id: generateNodeId(_id, BUTTON.displayName),
					},
					componentProps: {
						other: {
							[COMPONENT_STATES.DEFAULT]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									buttonShapeType: BUTTON_SHAPE_TYPES.SQUARED,
								},
							},
						},
						styles: {
							[COMPONENT_STATES.DEFAULT]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									backgroundColor: 'rgb(0, 168, 126)',
								},
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DESKTOP]: {
									width: '18.44vw',
									height: '4.88vw',
									fontSize: '1.56vw',
									lineHeight: '1.76vw',
									borderRadius: '0.49vw',
								},
								[DEFAULT_MEDIA_QUERY_PLATFORMS.TABLET]: {
									width: '22.30vw',
									height: '6.66vw',
									fontSize: '2.33vw',
									lineHeight: '2.50vw',
									borderRadius: '0.49vw',
								},
								[DEFAULT_MEDIA_QUERY_PLATFORMS.MOBILE]: {
									width: '78.44vw',
									height: '14.06vw',
									fontSize: '5.63vw',
									lineHeight: '5.94vw',
									borderRadius: '0.94vw',
								},
							},
							[COMPONENT_STATES.HOVER]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									backgroundColor: 'rgb(0, 196, 148)',
								},
							},
						},
					},
				},
				children: {
					[COMPONENT_STATES.DEFAULT]: {
						[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: getText(dictionary, type, 'text'),
					},
				},
			};
		},
	};
};

BUTTON.displayName = 'Button';
